import { InnerBlocks } from '@wordpress/block-editor';

export default function Save() {
    return (
        <div>
            <InnerBlocks.Content />
        </div>
    );
}